var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { appBorders } from '@backrs_ui/common-ui/src/assets/appBorders';
import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { BackrsIcon } from '@backrs_ui/common-ui/src/atoms/BackrsIcon';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { TermsAndConditions } from './TermsAndConditions';
import { BackrsForm } from '../BackrsForm/BackrsForm';
var REGISTER_STRINGS = appStrings.modules.register;
export var Register = function (_a) {
    var _b, _c, _d;
    var handleRegistration = _a.handleRegistration, errorMessage = _a.errorMessage, registerId = _a.registerId, preFilledData = _a.preFilledData;
    var _e = useState(false), isPasswordVisible = _e[0], setIsPasswordVisible = _e[1];
    var _f = useState(false), isRegistering = _f[0], setIsRegistering = _f[1];
    var defaultRegistrationValues = __assign({ first_name: (_b = preFilledData === null || preFilledData === void 0 ? void 0 : preFilledData.first_name) !== null && _b !== void 0 ? _b : '', last_name: (_c = preFilledData === null || preFilledData === void 0 ? void 0 : preFilledData.last_name) !== null && _c !== void 0 ? _c : '', phone: '', email: (_d = preFilledData === null || preFilledData === void 0 ? void 0 : preFilledData.email) !== null && _d !== void 0 ? _d : '', password: '', invite_code: '', is_fourteen_plus: '' }, (registerId && { register_id: registerId }));
    var methods = useForm({
        defaultValues: defaultRegistrationValues,
    });
    var fields = [
        {
            id: 'first_name',
            name: 'first_name',
            placeholder: REGISTER_STRINGS.firstNamePlaceholder,
            type: 'text',
            autoComplete: 'firstName',
            autoFocus: true,
            rules: {
                required: REGISTER_STRINGS.error.firstNameRequired,
            },
        },
        {
            id: 'last_name',
            name: 'last_name',
            placeholder: REGISTER_STRINGS.lastNamePlaceholder,
            type: 'text',
            autoComplete: 'lastName',
            rules: {
                required: REGISTER_STRINGS.error.lastNameRequired,
            },
        },
        {
            id: 'phone',
            name: 'phone',
            placeholder: REGISTER_STRINGS.phonePlaceholder,
            type: 'tel',
            autoComplete: 'phone',
            rules: {
                required: REGISTER_STRINGS.error.phoneRequired,
                pattern: { value: /^\d{10}$/, message: REGISTER_STRINGS.error.invalidPhone },
            },
        },
        {
            id: 'email',
            name: 'email',
            placeholder: REGISTER_STRINGS.emailPlaceholder,
            type: 'text',
            autoComplete: 'email',
            rules: {
                required: REGISTER_STRINGS.error.emailRequired,
                pattern: { value: /^\S+@\S+$/i, message: REGISTER_STRINGS.error.invalidEmail },
            },
        },
        {
            id: 'password',
            name: 'password',
            placeholder: REGISTER_STRINGS.passwordPlaceholder,
            type: isPasswordVisible ? 'text' : 'password',
            autoComplete: 'current-password',
            icon: {
                type: 'RIGHT_ICON',
                rightIcon: 'Visibility',
                rightIconColor: appColors.neutral.lightGray,
                onRightIconClick: function () { return setIsPasswordVisible(function (prev) { return !prev; }); },
            },
            rules: { required: REGISTER_STRINGS.error.passwordRequired },
        },
        {
            id: 'invite_code',
            name: 'invite_code',
            placeholder: REGISTER_STRINGS.inviteCodePlaceholder,
            type: 'text',
        },
    ];
    var handleSubmission = function (data) {
        setIsRegistering(true);
        var transformedData = {
            first_name: data.first_name,
            last_name: data.last_name,
            phone: data.phone,
            email: data.email,
            password: data.password,
            invite_code: data.invite_code ? data.invite_code : null,
            is_fourteen_plus: !!data.is_fourteen_plus,
            register_id: registerId !== null && registerId !== void 0 ? registerId : null,
        };
        handleRegistration(transformedData);
    };
    return (_jsxs(Box, { sx: containerStyle, children: [_jsx(BackrsIcon, { name: "BackrsWithText", alt: appStrings.modules.login.backrsLogoAlt, style: responsiveBackrsLogoStyle }), _jsxs(Box, { sx: loginFormStyle, children: [_jsx(Typography, { variant: "h4", sx: titleStyle, children: REGISTER_STRINGS.title }), _jsx(BackrsForm, { fields: fields, onSubmit: handleSubmission, buttonLabel: REGISTER_STRINGS.buttonLabel, methods: methods, isLoading: isRegistering, children: _jsx(FormControlLabel, { label: REGISTER_STRINGS.ageCertification, sx: checkboxLabelStyle, control: _jsx(Controller, { name: "is_fourteen_plus", control: methods.control, rules: { required: '', validate: function (value) { return "".concat(value) === 'true'; } }, render: function (_a) {
                                    var controllerField = _a.field;
                                    return (_jsx(Checkbox, __assign({}, controllerField, { checked: !!controllerField.value, sx: checkboxStyle })));
                                } }, "is_fourteen_plus") }) }), _jsx(TermsAndConditions, {}), errorMessage && (_jsx(Box, { mt: 2, color: appColors.color.red1, children: errorMessage }))] })] }));
};
var containerStyle = {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    px: 4,
};
var titleStyle = {
    color: appColors.color.navy3,
    fontWeight: 700,
    mb: 3,
};
var loginFormStyle = __assign({ backgroundColor: appColors.neutral.white, paddingX: 2, paddingY: 3, borderRadius: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: '100%', width: '100%', boxSizing: 'border-box', '@media (min-width: 300px)': {
        paddingX: 2,
        paddingY: 4,
    }, '@media (min-width: 600px)': {
        maxWidth: '500px',
        paddingX: 11,
        paddingY: 8,
    } }, appBorders.backrsDropShadowBorders.black);
var responsiveBackrsLogoStyle = {
    width: '100%',
    maxWidth: '175px',
    padding: '8px',
    marginBottom: '32px',
};
var checkboxLabelStyle = {
    '.MuiFormControlLabel-label': {
        color: appColors.color.navy2,
        fontSize: '0.75rem',
    },
};
var checkboxStyle = {
    color: appColors.color.navy2,
    '&.Mui-checked': {
        color: appColors.color.navy2,
    },
};
